import {
    ActionIcon,
    Group,
    Menu,
    Tooltip,
    UnstyledButton,
    rem,
} from '@mantine/core';
import { IconChartDots2, IconPencil, IconRefresh } from '@tabler/icons-react';

import useRefreshDataSet from '../../../../../http/mutations/data/useRefreshDataSet';

const ActionsColumn = ({
    handleEdit,
    row: { original: rowData },
    handleTimeline,
}) => {
    const { isPending: refreshPending, mutate: refreshSet } =
        useRefreshDataSet();

    const handleStatRefresh = () => {
        if (refreshPending) {
            return;
        }

        refreshSet({
            id: rowData.id,
            action: 'stats',
        });
    };

    return (
        <Group gap={'xs'}>
            <ActionIcon
                variant='default'
                size={'sm'}
                onClick={() => handleEdit(rowData)}>
                <IconPencil size={16} />
            </ActionIcon>

            <Tooltip label={'Refresh stats'}>
                <ActionIcon
                    variant='default'
                    size={'sm'}
                    disabled={refreshPending}
                    onClick={() => handleStatRefresh(rowData)}>
                    <IconRefresh size={16} />
                </ActionIcon>
            </Tooltip>

            <Tooltip label={'Send Timeline'}>
                <ActionIcon
                    variant='default'
                    size={'sm'}
                    onClick={() => handleTimeline(rowData)}>
                    <IconChartDots2 size={16} />
                </ActionIcon>
            </Tooltip>
        </Group>
    );
};
export default ActionsColumn;
